document.addEventListener('DOMContentLoaded', function () {
  const hairColourSelect = document.getElementById('hair-colour');
  if (!hairColourSelect) return;

  // Inject a hidden input directly into the product form on page load
  function injectHiddenInput() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    // Remove any existing one first
    const existing = productForm.querySelector('input[name="properties[Hair Colour]"]');
    if (existing) existing.remove();

    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[Hair Colour]';
    hidden.value = hairColourSelect.value;
    productForm.appendChild(hidden);
  }

  // Update hidden input whenever dropdown changes
  hairColourSelect.addEventListener('change', function () {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    let hidden = productForm.querySelector('input[name="properties[Hair Colour]"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Hair Colour]';
      productForm.appendChild(hidden);
    }
    hidden.value = this.value;
  });

  // Run on load
  injectHiddenInput();
});

